// extracted by mini-css-extract-plugin
export var container = "_ij-0";
export var infoIcon = "_ij-2";
export var titleRowCol = "_ij-1";